import { connect } from "react-redux";
import SalesforceExeSetting from "../components/AccountSetting/Salesforce/SalesforceExeSetting/SalesforceExeSetting";
import { goBack, push } from "react-router-redux";
import * as actions from "../redux/actions/Salesforce";
import { getUser } from "../redux/actions/AccountSetting";
import { SalesforceSettingDirectory } from "../constants/ComponentTypes";

const mapStateToProps = (state) => ({
  user: state.accountSetting.user,
  tab: SalesforceSettingDirectory.EXE_LIST.value,
  errorMessage: state.sfdcExeSetting.errorMessage,
  shortMessage: state.sfdcExeSetting.shortMessage,
  successMessage: state.sfdcExeSetting.successMessage,
  expiredAccessError: state.sfdcExeSetting.expiredAccessError,
  accountFields: state.sfdcExeSetting.accountFields,
  contactFields: state.sfdcExeSetting.contactFields,
  leadFields: state.sfdcExeSetting.leadFields,
  isLoadingFields: state.sfdcExeSetting.isLoadingFields,
  isConfiguring: state.sfdcExeSetting.isConfiguring,
  mapping: state.sfdcExeSetting.mapping,
  isLoadingMapping: state.sfdcExeSetting.isLoadingMapping,
  isImporting: state.salesforce.isImporting,
});

const mapDispatchToProps = (dispatch) => ({
  goBack() {
    dispatch(goBack());
  },

  goTo(url, state) {
    dispatch(push(url, state));
  },

  getUserInfo() {
    dispatch(getUser(true));
  },

  getSalesforceDescribeExeExport() {
    dispatch(actions.getSalesforceDescribeExeExport());
  },

  postSalesforceExportMappingsExe(data) {
    dispatch(actions.postSalesforceExportMappingsExe(data));
  },

  getSalesforceExportMappings(data) {
    dispatch(actions.getSalesforceExportMappings(data));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SalesforceExeSetting);



// WEBPACK FOOTER //
// ./src/containers/SalesforceExeSetting.js